import { Injectable } from "@angular/core";
import { ApplicationState } from "@feature/store/application-store";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { EntityKey } from '@pma-entity/pma-entity-types';
import { Details } from '@details/Interfaces/details';
import * as detailsActions from '@feature/_app_modules/mojo-details-widget/ngrx/mojo-details-widget.actions';
import { selectDetails } from '@feature/_app_modules/mojo-details-widget/ngrx/mojo-details-widget.selectors';

@Injectable({
  providedIn: 'root'
})
export class MojoDetailsWidgetFacadeService {

  constructor(
    private readonly store: Store<ApplicationState>
  ) {
  }

  loadDetailsData(entityName: string, key: EntityKey | undefined) {
    this.store.dispatch(detailsActions.loadDetails({ id: entityName, entityName, key }));
  }

  getDetails(entityName: string): Observable<Details> {
    return this.store.pipe(
      select(selectDetails(entityName)));
  }
}
